import { Country } from "../../postal/country.model";
import { AddressableUser } from "../../user/addressable-user.model";

export class Dealer extends AddressableUser {
    public static override stringifyExclude: string[] = [
        "_user_roles"
    ];

    private _name: string = "";

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get primary_contact_first_name(): string {
        return super.first_name
    }

    public set primary_contact_first_name(value: string) {
        super.first_name = value;
    }

    public get primary_contact_last_name(): string {
        return super.last_name;
    }

    public set primary_contact_last_name(value: string) {
        super.last_name = value;
    }

    public get primary_contact_email(): string {
        return super.email;
    }

    public set primary_contact_email(value: string) {
        super.email = value;
    }

    public get primary_contact_phone(): string {
        return super.phone;
    }

    public set primary_contact_phone(value: string) {
        super.phone = value;
    }

    public override toJSON() {
        return super.toJSON(Dealer.stringifyExclude);
    }

    public override flatten(exclude: string[]): Object {
        let outObj = Object.create(null);

        for (let key in this) {
            let k: string = key;

            if (k == "_first_name") {
                k = "_primary_contact_first_name";
            } else if (k == "_last_name") {
                k = "_primary_contact_last_name";
            } else if (k == "_email") {
                k = "_primary_contact_email";
            } else if (k == "_phone") {
                k = "_primary_contact_phone";
            }

            outObj = this.addProperty(this, outObj, k, exclude);
        }

        return outObj;
    }

    public static toDealers(obj: string | Object[]): Dealer[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let dealers: Dealer[] = [];

        for (const o2 of (<Object[]>obj2)) {
            dealers.push(Dealer.toDealer(o2));
        }

        return dealers;
    }

    public static toDealer(obj: string | Object): Dealer {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of Dealer.
        const dealer = Object.assign(new Dealer(), obj2);

        if (dealer.country != null) {
            dealer.country = Country.toCountry(dealer.country);
        }

        return dealer;
    }
}    
